import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { utilService } from "services";
import { useSelector } from "react-redux";
import { Col, Container, Row, Button } from "react-bootstrap";
import * as Yup from "yup";

const Contact = ({ isOutSideCalled }) => {
    const [serverError, setServerError] = useState(null);
    const { user } = useSelector((state) => state.auth);

    const contactValidationSchema = Yup.object().shape({
    firstName: Yup.string()
        .required("Please Enter first name")
        .max(15, "First Name must be at most 15 characters"),
    lastName: Yup.string()
        .required("Please Enter last name")
        .max(15, "Last Name must be at most 15 characters"),
    phone: Yup.string()
        .required("Please Enter phone number")
        .matches(/^\d{10}$/, "Please enter a valid 10-digit phone number"),
    email: Yup.string()
        .required("Please Enter email")
        .email("Enter valid email")
        .matches(
            /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            "Enter valid email"
        ),
    message: Yup.string().required("Please Enter Message"),
});

    const formik = useFormik({
        initialValues: {
            firstName: user?.firstName || "",
            lastName: user?.lastName || "",
            phone: user?.phone || "",
            email: user?.email || "",
            countryCode: "+1",
            message: "",
        },
        enableReinitialize: true,
        validationSchema: contactValidationSchema,
        onSubmit: async (values) => {
            try {
                const response = await utilService.contactUs(values);
                toast.success(response?.data?.message);
                formik.resetForm();
            } catch (err) {
                const errorMessage = err?.response?.data?.message || "Something went wrong";
                console.error(errorMessage);
                setServerError(errorMessage);
                toast.error(errorMessage);
            }
        },
    });

    const handlePhoneChange = (value) => {
        const digitsOnly = value.replace(/\D/g, "");
        const phoneNumber = digitsOnly.startsWith("1") ? digitsOnly.slice(1) : digitsOnly;

        formik.setFieldValue("phone", phoneNumber);
        formik.setFieldValue("countryCode", "+1");
    };

    useEffect(() => {
        const keyDownHandler = (event) => {
            if (event.key === "Enter") {
                formik.handleSubmit();
            }
        };
        document.addEventListener("keydown", keyDownHandler);
        return () => document.removeEventListener("keydown", keyDownHandler);
    }, [formik.handleSubmit]);

    return (
        <div className="advertise-page" style={isOutSideCalled ? { marginTop: "100px" } : {}}>
            <Container>
                <Row className="justify-content-center">
                    <Col xl={6} lg={8} md={10} xs={12}>
                        <div className="advertise-card">
                            <h2 className="advertise-section-heading">Contact Us</h2>
                            <h5 className="advertise-sub-heading mobile-sub-heading">
                                Fill the details
                            </h5>
                            <div className="form-div">
                                <form onSubmit={formik.handleSubmit} noValidate>
                                    <div className="row">
                                        <div className="col-lg-6 mb-30 text-left">
                                            <label className="py-2">First Name</label>
                                            <input
                                                type="text"
                                                placeholder="Enter First Name"
                                                className="form-control w-100"
                                                {...formik.getFieldProps('firstName')}

                                            />
                                            {formik.touched.firstName && formik.errors.firstName ? (
                                                <span className="text-danger">
                                                    {formik.errors.firstName}
                                                </span>
                                            ) : null}
                                        </div>
                                        <div className="col-lg-6 mb-30 text-left">
                                            <label className="py-2">Last Name</label>
                                            <input
                                                type="text"
                                                placeholder="Enter Last Name"
                                                className="form-control w-100"
                                                {...formik.getFieldProps('lastName')}
                                            />
                                            {formik.touched.lastName && formik.errors.lastName ? (
                                                <span className="text-danger">
                                                    {formik.errors.lastName}
                                                </span>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="mb-30 text-left">
                                        <label className="py-2">Email</label>
                                        <input
                                            type="text"
                                            placeholder="Enter Email"
                                            className="form-control w-100"
                                            {...formik.getFieldProps('email')}
                                        />
                                        {formik.touched.email && formik.errors.email ? (
                                            <span className="text-danger">{formik.errors.email}</span>
                                        ) : null}
                                    </div>

                                    <div className="mb-30 text-left">
                                        <label className="py-2">Mobile Number</label>
                                        <PhoneInput
                                            country="us"
                                            onlyCountries={["us"]}
                                            disableDropdown={true}
                                            countryCodeEditable={false}
                                            placeholder="Enter phone number"
                                            name="phone"
                                            id="phone-field"
                                            onChange={handlePhoneChange}
                                            onBlur={formik.handleBlur}
                                            value={`${formik.values.countryCode}${formik.values.phone}`}
                                        />
                                        {formik.touched.phone && formik.errors.phone ? (
                                            <span className="text-danger">{formik.errors.phone}</span>
                                        ) : null}
                                    </div>

                                    <div className="mb-30 text-left">
                                        <label className="py-2">Message</label>
                                        <div className="textrea-overlay w-100">
                                            <textarea
                                                className="form-control w-100 textarea-height193"
                                                placeholder="Type your message here..."
                                                {...formik.getFieldProps('message')}
                                                maxLength={1000}
                                                style={{ minHeight: '150px' }}
                                            ></textarea>
                                        </div>

                                        <label className="d-block text-end pt-1 pe-1">
                                            {formik.values.message.length}/1000
                                        </label>
                                        {formik.touched.message && formik.errors.message ? (
                                            <span className="text-danger">
                                                {formik.errors.message}
                                            </span>
                                        ) : null}
                                    </div>

                                    {serverError && <div className="text-danger mb-4 text-center">{serverError}</div>}

                                    <div className="text-center">
                                        <Button
                                            type="submit"
                                            disabled={formik.isSubmitting}
                                            className="btn btn-primary w-100 mt-0"
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Contact;
